import { OBTAIN_USER_TOKEN } from 'common/apiRoutes'
import RouterHelper, { IExtendedBackendRouter } from 'lib/BackendRouter'
import { IDispatch, IAPIResponse } from 'common/interfaces.d'
import {
  receiveUserAccessToken,
  fetchingUserAccessTokenFailed
} from './actionCreators'

const Router: IExtendedBackendRouter = RouterHelper()

export const fetchUserToken: any = async (
  _getStore: () => any,
  dispatch: IDispatch,
  authorizedGetWrapper: any,
  callback?: () => void
) => {
  const endpoint: string = Router.generate(OBTAIN_USER_TOKEN)

  try {
    const result: IAPIResponse = await authorizedGetWrapper(endpoint)

    dispatch(receiveUserAccessToken(result.body.response))
  } catch (error) {
    dispatch(fetchingUserAccessTokenFailed())
  }

  callback && callback()
}

export const setupInitialUserToken = async (
  getStore: () => any,
  dispatch: IDispatch,
  authorizedGetWrapper: any
) => {
  const currentJWT = document.getElementById('start')?.dataset?.jwt
  const merchantUserUuid = document.getElementById('start')?.dataset?.userUuid

  if (currentJWT && merchantUserUuid) {
    return dispatch(
      receiveUserAccessToken({
        accessToken: currentJWT,
        uuid: merchantUserUuid,
        expirationTime: 0
      })
    )
  }

  return await fetchUserToken(getStore, dispatch, authorizedGetWrapper)
}
